import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import OutsideClickHandler from 'react-outside-click-handler';
import { XCircle } from 'react-bootstrap-icons';
import { notificationActions } from '../../data/notification';
import { useDispatch, useSelector } from 'react-redux';
import useT from '../../i18n/useT';

const CreateVehicle = ({formData, setFormData, show, setShow, action, loading, setLoading, submit, setStep, step, car_id}) => {
    const [cities, setCities] = useState([]);
    const lang = useSelector((state) => state.user.language);
    const t = useT();
    const [filteredCities, setFilteredCities] = useState([]);
    const [showCities, setShowCities] = useState(false);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [showUsers, setShowUsers] = useState(false);
    const [users, setUsers] = useState([]);
    const dispatch = useDispatch();
    const [category, setCategory] = useState("");
    const [auctionImages, setAuctionImages] = useState(null);
    const ports = ["Port of WA Washington", "Port of CA California", "Port of TX Texas", "Port of GA Georgia", "Port of NJ New Jersey"];
    const categoryPrices = {A: 50, B: 100, C: 150, D: 200, E: 250, F: 300, G: 350, H: 400}
    const handlers = {
        vinDecode(){
            axios(`https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/${formData.vin}?format=json`)
                .then((res) => {
                    const result = res.data.Results;
                    if(result.length > 0){
                        setFormData((prev) => ({...prev, mark: result[0].Make, model: result[0].Model, year: result[0].ModelYear}))
                    }
                })
                .catch((err) => {

                })
        },
        uploadAuctionImages(e){
            e.preventDefault();
            setLoading(true);
            const carData = new FormData();
            carData.append('vin', formData.vin);
            for(let i = 0; i < auctionImages.length; i++){
                carData.append("auction-images", auctionImages[i])
            }
            axios.post(`/api/cars/${car_id}/auction-images`, carData)
                .then((res) => {
                    setLoading(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setShow(false);
                    setStep(1);
                })
                .catch((err) => {
                    setLoading(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })

        }
    }

    useEffect(() => {
        axios('/api/cities')
            .then((res) => {
                const data = res.data.data;
                setCities(data);
                setFilteredCities(data);
            })
            .catch((err) => {

            })

        axios(`/api/users?limit=500&page=1&keyword=&asc=desc&calculator_category=&role=&sort_by=id`)
            .then((res) => {
                setUsers(res.data.data);
                setFilteredUsers(res.data.data);
            })
            .catch((err) => {

            })
    }, [])

    return <Modal show={show} onHide={() => setShow(false)} size='xl' centered>
        <Modal.Header closeButton><h3>{action === "edit" ? t("vehicles.modifyCarData") : t("vehicles.addNewCar")}</h3></Modal.Header>
        <Modal.Body>
            {step == 1 && <form onSubmit={submit}>
                <div className='row'>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.user")}</label>
                            <input type='text' placeholder={t("vehicles.enterUser")} onClick={() => {
                                setShowUsers(true);
                            }} className='form-control' value={formData.user} onChange={(e) => {
                                setFormData((prev) => ({...prev, user: e.target.value}));
                                const filtered = users.filter((u) => `${u.name} ${u.surname} ${u.username} ${u.email}`.toLowerCase().includes(e.target.value.toLowerCase()));
                                setFilteredUsers(filtered);
                            }}/>
                            {showUsers && <OutsideClickHandler onOutsideClick={() => setShowUsers(false)}>
                                <div className='booking-vin-code-suggestions'>
                                    {     
                                        filteredUsers.map((user) => <div key={user.id} onClick={() => {
                                            setFormData((prev) => ({...prev, dealer_id: user.id, user: `${user.name} ${user.surname}`}));
                                            setCategory(user.calculator_category)
                                            setShowUsers(false);
                                        }}>{user.username} - {user.name} {user.surname}</div>)
                                    }
                                    {
                                        filteredUsers.length == 0 && <div style={{textAlign: "center", width: "100%"}}>{t("vehicles.userNotFound")}</div>
                                    }
                                </div>
                            </OutsideClickHandler>}
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>VIN</label>
                            <input onKeyDown={(e) => {
                                if(e.keyCode == 13){
                                    e.preventDefault();
                                    handlers.vinDecode();
                                }
                            }} type='text' placeholder={t("vehicles.enterVin")} className='form-control' value={formData.vin} onChange={(e) => setFormData((prev) => ({...prev, vin: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.mark")}</label>
                            <input type='text' placeholder={t("vehicles.enterMark")} className='form-control' value={formData.mark} onChange={(e) => setFormData((prev) => ({...prev, mark: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.model")}</label>
                            <input type='text' placeholder={t("vehicles.enterModel")} className='form-control' value={formData.model} onChange={(e) => setFormData((prev) => ({...prev, model: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.year")}</label>
                            <input type='text' placeholder={t("vehicles.enterYear")} className='form-control' value={formData.year} onChange={(e) => setFormData((prev) => ({...prev, year: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.lotNumber")}</label>
                            <input type='text' placeholder={t("vehicles.enterLotNumber")} className='form-control' value={formData.lot_number} onChange={(e) => setFormData((prev) => ({...prev, lot_number: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.auction")}</label>
                            <select className='form-control' value={formData.auction} onChange={(e) => {
                                setFormData((prev) => ({...prev, auction: e.target.value}));
                                const auctionFiltered = cities.filter((c) => c.auction.toLowerCase().includes(e.target.value.toLowerCase()));
                                setFilteredCities(auctionFiltered);
                            }}>
                                <option value={""}>{t("vehicles.selectAuction")}</option>
                                <option value={"Copart"}>Copart</option>
                                <option value={"IAAI"}>IAAI</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.usState")}</label>
                            <input disabled={formData.auction == ""} type='text' onClick={() => setShowCities(true)} placeholder={t("vehicles.enterUsState")} className='form-control' value={formData.us_state} onChange={(e) => {
                                setFormData((prev) => ({...prev, us_state: e.target.value}))
                                const data = cities.filter((city) => city.city.toLowerCase().includes(e.target.value.toLowerCase()) && city.auction.toLowerCase() == formData.auction.toLowerCase())
                                setFilteredCities(data);
                            }}/>
                            {showCities && <OutsideClickHandler onOutsideClick={() => setShowCities(false)}>
                                <div className='booking-vin-code-suggestions'>
                                    {
                                        filteredCities.map((city) => <div key={city.id} onClick={() => {
                                            const port = city.port.replace("(პორტი ", "").replace(")", "");
                                            const selected = ports.filter((p) => p.toLowerCase().includes(port.toLowerCase()));
                                            setFormData((prev) => ({...prev, us_state: city.city, us_port: selected[0], total_price: parseInt(city.total_price) + categoryPrices[category]}));
                                            setShowCities(false);
                                        }}>{city.city}</div>)
                                    }
                                    {
                                        filteredCities.length == 0 && <div style={{textAlign: "center", width: "100%"}}>{t("vehicles.cityNotFound")}</div>
                                    }
                                </div>
                            </OutsideClickHandler>}
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.usPort")}</label>
                            <select className='form-control' value={formData.us_port} onChange={(e) => setFormData((prev) => ({...prev, us_port: e.target.value}))}>
                                <option>{t("vehicles.selectDestinationPort")}</option>
                                {
                                    ports.map((port, id) => <option key={id} value={port}>{port}</option>)
                                }
                            </select>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.destinationPort")}</label>
                            <select className='form-control' value={formData.destination_port} onChange={(e) => setFormData((prev) => ({...prev, destination_port: e.target.value}))}>
                                <option>{t("vehicles.selectDestinationPort")}</option>
                                <option value={"Poti"}>Poti</option>
                                <option value={"Batumi"}>Batumi</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.documentType")}</label>
                            <input type='text' placeholder={t("vehicles.enterDocType")} className='form-control' value={formData.doc_type} onChange={(e) => setFormData((prev) => ({...prev, doc_type: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.titleReceivedDate")}</label>
                            <input type='date' className='form-control' value={formData.title_received_date || ""} onChange={(e) => setFormData((prev) => ({...prev, title_received_date: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.containerCost")}</label>
                            <input type='text' placeholder={t("vehicles.enterContainerCost")} className='form-control' value={formData.container_cost} onChange={(e) => setFormData((prev) => ({...prev, container_cost: e.target.value, landing_cost: prev.total_price == "" ? prev.landing_cost : prev.total_price - e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.landingCost")}</label>
                            <input type='text' placeholder={t("vehicles.enterLandingCost")} className='form-control' value={formData.landing_cost} onChange={(e) => setFormData((prev) => ({...prev, landing_cost: e.target.value, container_cost: prev.total_price == "" ? prev.container_cost : prev.total_price - e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.vehiclePrice")}</label>
                            <input type='text' placeholder={t("vehicles.enterVehiclePrice")} className='form-control' value={formData.vehicle_price} onChange={(e) => setFormData((prev) => ({...prev, vehicle_price: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.totalPrice")}</label>
                            <input type='text' placeholder={t("vehicles.enterTotalPrice")} className='form-control' value={formData.total_price} onChange={(e) => setFormData((prev) => ({...prev, total_price: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.vehicleAdditionalAmount")}</label>
                            <input type='text' placeholder={t("vehicles.enterTotalPrice")} className='form-control' value={formData.car_additional_amount} onChange={(e) => setFormData((prev) => ({...prev, car_additional_amount: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.transportationAdditionalAmount")}</label>
                            <input type='text' placeholder={t("vehicles.enterTotalPrice")} className='form-control' value={formData.transportation_additional_amount} onChange={(e) => setFormData((prev) => ({...prev, transportation_additional_amount: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.buyerNumber")}</label>
                            <input type='text' placeholder={t("vehicles.enterBuyerNumber")} className='form-control' value={formData.buyer_number} onChange={(e) => setFormData((prev) => ({...prev, buyer_number: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.vehicleType")}</label>
                            <select value={formData.vehicle_type} onChange={(e) => setFormData((prev) => ({...prev, vehicle_type: e.target.value}))} className='form-control'>
                                <option value={""}>{t("vehicles.selectVehicleType")}</option>
                                <option value={"sedan"}>{t("vehicles.typeSedan")}</option>
                                <option value={"jeep"}>{t("vehicles.typeJeep")}</option>
                                <option value={"jeep-oversize"}>{t("vehicles.typeJeepOversize")}</option>
                                <option value={"minivan"}>{t("vehicles.typeMinivan")}</option>
                                <option value={"micro-bus"}>{t("vehicles.typeMicrobus")}</option>
                                <option value={"jet-snowmobile"}>{t("vehicles.typeJetski")}</option>
                                <option value={"motorcycle"}>{t("vehicles.typeMotorcycle")}</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <label>{t("vehicles.purchaseDate")}</label>
                            <input type='date' className='form-control' value={formData.purchase_date} onChange={(e) => setFormData((prev) => ({...prev, purchase_date: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        {(formData.is_insured || formData.is_insured == 1) && <div className='form-group'>
                            <label>{t("vehicles.insuranceType")}</label>
                            <select value={formData.insuranse_type} onChange={(e) => {
                                const GPI = parseInt(formData.vehicle_price) / 100 > 100 ? parseInt(formData.vehicle_price) / 100 : 100;
                                const Office = parseInt(formData.vehicle_price) / 200 > 50 ? parseInt(formData.vehicle_price) / 200 : 50;
                                const insuransePrice = e.target.value == "GPI" ? GPI : Office;
                                setFormData((prev) => ({...prev, insuranse_type: e.target.value, insuranse_price: insuransePrice, total_price: parseInt(prev.total_price) - parseInt(prev.insuranse_price) + parseInt(insuransePrice)}));
                            }} className='form-control'>
                                <option value={"GPI"}>GPI</option>
                                <option value={"Office"}>Office</option>
                            </select>
                        </div>}
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <input id='has-key' type='checkbox' value={formData.has_key} defaultChecked={formData.has_key == 1} onChange={(e) => setFormData((prev) => ({...prev, has_key: e.target.checked}))}/>
                            <label htmlFor='has-key' style={{marginLeft: "5px"}}>{t("vehicles.hasKey")}</label>
                        </div>
                        <div className='form-group'>
                            <input type='checkbox' id='is-hybrid' value={formData.is_hybrid} defaultChecked={formData.is_hybrid == 1} onChange={(e) => setFormData((prev) => {
                                const totalPrice = e.target.checked ? parseInt(prev.total_price) + 50 : parseInt(prev.total_price) - 50;
                                return {...prev, is_hybrid: e.target.checked, total_price: totalPrice}
                            })}/>
                            <label htmlFor='is-hybrid' style={{marginLeft: "5px"}}>{t("vehicles.isHybrid")}</label>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <input id='is-sublot' type='checkbox' value={formData.is_sublot} defaultChecked={formData.is_sublot == 1} onChange={(e) => setFormData((prev) => {
                                const totalPrice = e.target.checked ? parseInt(prev.total_price) + 50 : parseInt(prev.total_price) - 50;
                                return {...prev, is_sublot: e.target.checked, total_price: totalPrice}
                            })}/>
                            <label htmlFor='is-sublot' style={{marginLeft: "5px"}}>{t("vehicles.isSublot")}</label>
                        </div>
                        <div className='form-group'>
                            <input type='checkbox' id='is-funded' value={formData.is_funded} defaultChecked={formData.is_funded == 1} onChange={(e) => setFormData((prev) => ({...prev, is_funded: e.target.checked}))}/>
                            <label style={{marginLeft: "5px"}} htmlFor='is-funded'>{t("vehicles.isFunded")}</label>
                        </div>
                        <div className='form-group'>
                            <input type='checkbox' id='is-closed-code' value={formData.is_closed_code} defaultChecked={formData.is_closed_code == 1} onChange={(e) => setFormData((prev) => ({...prev, is_closed_code: e.target.checked}))}/>
                            <label style={{marginLeft: "5px"}} htmlFor='is-closed-code'>{t("vehicles.isClosedCode")}</label>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4'>
                        <div className='form-group'>
                            <input type='checkbox' value={formData.is_insured} id='is-insured' defaultChecked={formData.is_insured == 1} onChange={(e) => {
                                setFormData((prev) => ({...prev, is_insured: e.target.checked}));
                                const GPI = parseInt(formData.vehicle_price) / 100 > 100 ? parseInt(formData.vehicle_price) / 100 : 100;
                                const Office = parseInt(formData.vehicle_price) / 200 > 50 ? parseInt(formData.vehicle_price) : 50;
                                const insuransePrice = formData.insuranse_type == "GPI" ? GPI : Office;
                                const totalPrice = e.target.checked ? parseInt(formData.total_price) + parseInt(insuransePrice.toFixed()) : parseInt(formData.total_price) - parseInt(insuransePrice.toFixed());
                                setFormData((prev) => ({...prev, total_price: totalPrice, insuranse_price: insuransePrice}));
                            }}/>
                            <label style={{marginLeft: "5px"}} htmlFor='is-insured'>{t("vehicles.isInsured")}</label>
                        </div>
                        <div className='form-group'>
                            <input id='pending' type='checkbox' value={formData.pending} defaultChecked={formData.pending == 1} onChange={(e) => setFormData((prev) => ({...prev, total_price: e.target.checked ? parseInt(prev.total_price) + 100 : prev.total_price - 100, pending: e.target.checked}))}/>
                            <label htmlFor='pending' style={{marginLeft: "5px"}}>{t("vehicles.pending")}</label>
                        </div>
                    </div>
                    {action == "add" && <div className='col-md-12 mt-4'>
                        <label htmlFor='car-main-image' className='attach-profile-button'>+{t("vehicles.attachImage")}</label>
                        <input id='car-main-image' type='file' hidden accept="image/*" onChange={(e) => {
                            setFormData((prev) => ({...prev, profile_image_url: e.target.files}));
                        }}/>
                        {
                            formData.profile_image_url != null && <div className='car-main-image'>
                                <XCircle onClick={() => setFormData((prev) => ({...prev, profile_image_url: null}))} width={"20px"} height={"20px"} style={{color: "white", position: "absolute", marginTop: "15px", marginLeft: "150px", cursor: "pointer"}}/>
                                <img src={URL.createObjectURL(formData.profile_image_url[0])} alt='car-profile' style={{width: "180px"}}/>
                                <span>{formData.profile_image_url[0].name.slice(0,20)}{formData.profile_image_url[0].name.length > 20 && "..."}</span>
                            </div>
                        }
                    </div>}
                </div>
                <Modal.Footer style={{marginTop: "1.5rem"}}>
                    <Button type='submit' variant={loading ? 'secondary' : 'primary'} disabled={loading}>{loading ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : action === "add" ? t("vehicles.saveAndAttach") : t("common.save")}</Button>
                    <Button type='button' onClick={() => setShow(false)} variant='danger'>{t("common.close")}</Button>
                </Modal.Footer>
            </form>}
            {
                step == 2 && <form onSubmit={handlers.uploadAuctionImages}>
                    <label htmlFor='attach-auction-images' className='attach-auction-images'><img src='/static/icons/image.png' style={{width: "50px"}}/><span>{t("vehicles.attachImage")}</span></label>
                    <input id='attach-auction-images' type='file'  hidden accept="image/*" multiple onChange={(e) => {
                        setAuctionImages((prev) => (prev== null ? Array.from(e.target.files) : [...prev, Array.from(e.target.files)]));
                    }}/>
                    <div className='auction-images-list'>
                        {
                            auctionImages != null && auctionImages.map((image, index) => {
                                return <div className='auction-image'>
                                    <XCircle onClick={() => {
                                        const imgs = auctionImages.filter((img, i) => i != index);
                                        setAuctionImages(imgs);
                                    }} width={"20px"} height={"20px"} style={{color: "white", position: "absolute", marginTop: "15px", marginLeft: "150px", cursor: "pointer"}}/>
                                    <img src={URL.createObjectURL(image)} style={{width: "180px"}}/>
                                </div>
                            })
                        }
                    </div>
                    <Modal.Footer style={{marginTop: "1.5rem"}}>
                        <Button type='submit' variant={loading ? 'secondary' : 'primary'} disabled={loading}>{loading ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : t("vehicles.upload")}</Button>
                        <Button type='button' onClick={() => setShow(false)} variant='danger'>{t("common.close")}</Button>
                    </Modal.Footer>
                </form>
            }
        </Modal.Body>
    </Modal>
}

export default CreateVehicle